<template>
  <div>
    <!-- <div class="qrcode">
      <img src="http://image.dingjian.name/uPic/qrcode110.png" alt="">
    </div> -->
    <Quan v-for="data in list" v-bind:key="data.id" :data="data"></Quan>
  </div>
</template>

<script>
import Quan from '@/components/quan.vue'
export default {
  name: "Waimai",
  components: {
    Quan,
  },
  data() {
    return {
      list: [
        // {id:5, type: "", title: "【淘宝】双十一超级红包", price: "6", tip: "每天都能领，最高6666元", url: "http://d.aqjh.net/uw1ah"},
        // {id:6, type: "", title: "【京东】双十一京享红包", price: "8", tip: "每天都能领，最高8888元", url: "https://u.jd.com/3LmuBU3"},
        {id:3, type: "meituan", title: "【推荐】美团外卖好时节🔥", price: "4", tip: "含满16元减2", url: "http://dpurl.cn/vr5UCGHz"},
        {id:4, type: "meituan", title: "美团38元外卖礼包", price: "43", tip: "含满25-4", url: "http://dpurl.cn/vr5UCGHz"},
        {id:1, type: "eleme", title: "【必领】饿了么翻倍大红包🔥", price: "20", tip: "1~20元随机(满20可用)", url: "http://short.zzlehao.com/2550803909?pwd=3aU6PzM"},
        {id:2, type: "eleme", title: "饿了么天天限时补贴", price: "12", tip: "含满30减5", url: "https://tb.ele.me/wow/ele-ad/act/elmtkhd?wh_biz=tm&from=cps_tk&ali_trackid=2:mm_224010009_1166500486_109862500127:1609074056_225_1663112849&e=-s022xT3ESPd0ExmJVHnonVt8ANxvj7I8mQwk82TscdRQS3Vmj9P8IHbnXzIg58FCJdsqEVpmfiew7Lxwaf6TZ9KOj5JFMhglsCyO0RxeGK92oQ9gILXTjcLROtXzrv15Y3KliYBp8duHowO7Jkv7413GMa3C8P2d5UVIV7OMIAEoPVhosEFcutklG7eoRhuGP5IipJ78I8f8QKTqH1codeaMzjlNl6evhIZCQO6NJznPLQbwTWQSBKqJSdVjUwS2JEmWUgKyNiqshPBoEAKxJu9ugaN&union_lens=lensId%3AAPP%401609074004%400b1463e4_0b62_176a448d26c_401b%40022omCVZUpTwJ3ZoC6GlZBKv"},
      ]
    }  
  }
}
</script>
<style scoped>
.qrcode {
  width: 100%;
}

.qrcode img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/waimai/index.vue